import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import renewalOption from "../fragments/renewalOption"

const query = gql`
  query PreviewRenewalQuote(
    $businessId: ID!
    $option: InputRenewalOption!
    $etag: String!
    $seats: Int
    $productsUpdated: [InputRenewalProduct]
    $productsAdded: [InputRenewalProduct]
    $productsRemoved: [InputRenewalProduct]
  ) {
    salesPreviewRenewalQuote(
      businessId: $businessId
      option: $option
      etag: $etag
      seats: $seats
      productsUpdated: $productsUpdated
      productsAdded: $productsAdded
      productsRemoved: $productsRemoved
    ) {
      etag
      options {
        ...renewalOption
      }
      winbackOption {
        ...renewalOption
      }
      errorType
      errorMessage
    }
  }
  ${renewalOption}
`

export const previewRenewalQuoteKey = getQueryNames(query)[0]

export default query
